import styled from '@emotion/styled';
import AddIcon from '@mui/icons-material/Add';
import { ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import { FC } from 'react';
import { WsColors, Item, WsTypography, WsTypoColors, WsTypoVariants } from 'wisestep-base';
export interface JobsPlaceholderProps {
  onClickPlaceholder(placeholder: string): void;
}
const StyledListItem = styled(ListItem)({
  backgroundColor: WsColors.White,
  borderRadius: 3,
  border: '1px solid' + WsColors.TheBlues200,
  cursor: 'pointer',
  padding: 12,
});
const StyleItem = styled(Item)(({ theme }) => ({
  padding: theme.spacing(1),
}));
const JobPlaceholder: FC<JobsPlaceholderProps> = ({ onClickPlaceholder }) => {
  const jobData = [
    { key: 'Job Title', value: '{{job.title}}' },
    { key: 'Job Code', value: '{{job.jobCode}}' },
    { key: 'Client Job Code', value: '{{job.clientJobCode}}' },
    { key: 'Job Type', value: '{{job.jobType}}' },
    { key: 'Job Description', value: '{{job.description}}' },
    { key: 'Tags', value: '{{job.tags}}' },
    { key: 'Skills', value: '{{job.skills}}' },
    { key: 'Client', value: '{{job.companyName}}' },
    { key: 'Client SPOC', value: '{{job.clientRecruiter}}' },
    {
      key: 'Compensation',
      value:
        '{{job.salaryCurrency}} {{job.minimumSalary}} - {{job.salaryCurrency}} {{job.maximumSalary}} {{job.salaryTimeSpan | splitByUpperCase}}',
    },
    { key: 'Job Location ( City, State)', value: '[{{job.locations_city_and_state}}]' },
    { key: 'Job Location ( City, Country)', value: '[{{job.locations_city_and_country}}]' },
    { key: 'Remote', value: '{{job.isRemote}}' },

    { key: 'Job Url', value: '{{job.jobUrl}}' },
    { key: 'Workplace Preference', value: '{{job.workplacePreference}}' },
  ];
  const handleListItemClick = (placeholder: string) => onClickPlaceholder(placeholder);
  return (
    <Box>
      {jobData.map(({ key, value }) => (
        <StyleItem key={key}>
          <StyledListItem onClick={() => handleListItemClick(value)}>
            <ListItemText primary={key} />
            <ListItemIcon>
              <AddIcon />
              <WsTypography color={WsTypoColors.PRIMARY} variant={WsTypoVariants.BODY1}>
                Add
              </WsTypography>
            </ListItemIcon>
          </StyledListItem>
        </StyleItem>
      ))}
    </Box>
  );
};
export default JobPlaceholder;
